/* Pages politiques Shopify : en-tête cuure + sommaire + articles en cartes (même style que la CGU GRENADINE+) */
(function () {
  var C = document.querySelector('.shopify-policy__container');
  if (!C || C.classList.contains('gcg-on')) return;
  var body = C.querySelector('.shopify-policy__body .rte') || C.querySelector('.shopify-policy__body');
  if (!body) { C.classList.add('gcg-on'); return; }

  var path = location.pathname.replace(/\/$/, '');
  var handle = path.split('/').pop();
  var HEADS = {
    'refund-policy': ['Retours et remboursements', 'de vos produits GRENADINE'],
    'shipping-policy': ['Livraison', 'et Click & Collect'],
    'terms-of-service': ['Conditions d’utilisation', 'du site grenadinehair.com'],
    'terms-of-sale': ['Conditions générales', 'de vente'],
    'legal-notice': ['Mentions légales', 'du site grenadinehair.com'],
    'privacy-policy': ['Confidentialité', 'et protection de vos données'],
    'subscription-policy': ['Politique d’annulation', 'des réservations et des achats'],
    'contact-information': ['Coordonnées', 'de GRENADINE']
  };
  var h1 = C.querySelector('.shopify-policy__title h1');
  var head = HEADS[handle] || [h1 ? h1.textContent.trim() : '', ''];

  var KEEP = /^(GRENADINE\+?|CGV|CGU|RGPD|CNIL|TVA|FAQ|SMS|RCS|SARL|UE|CM2C|MECHICHE|CO)$/;
  function nice(t) {
    t = t.replace(/\s+/g, ' ').trim();
    var letters = t.replace(/[^A-Za-zÀ-ÿ]/g, '');
    if (letters && letters === letters.toUpperCase()) {
      t = t.split(' ').map(function (w, i) {
        var bare = w.replace(/[^A-Za-zÀ-ÿ+]/g, '');
        if (KEEP.test(bare)) return w;
        w = w.toLowerCase();
        return i === 0 ? w.charAt(0).toUpperCase() + w.slice(1) : w;
      }).join(' ');
    }
    return t;
  }
  function isUpperHead(t) {
    t = t.replace(/\s+/g, ' ').trim();
    var letters = t.replace(/[^A-Za-zÀ-ÿ]/g, '');
    return letters.length >= 4 && t.length <= 110 && letters === letters.toUpperCase();
  }
  function isSub(t) { return !!t && t.length <= 70 && !/[.:;,!?…]$/.test(t) && !/^[–\-•\d]/.test(t) && !/@|www\./.test(t); }
  function esc(t) { var d = document.createElement('div'); d.textContent = t; return d.innerHTML; }
  function normTitle(t) { return t.toLowerCase().replace(/[^a-zà-ÿ]/g, ''); }

  /* 1. Découpe le contenu en blocs { head, html } */
  var blocks = [], cur = { head: null, html: '' };
  function push() { if (cur.head !== null || cur.html.replace(/<[^>]+>|&nbsp;|\s/g, '')) blocks.push(cur); }
  Array.prototype.forEach.call(body.children, function (el) {
    var tag = el.tagName;
    var txt = el.textContent.replace(/ /g, ' ').trim();
    if (/^H[1-6]$/.test(tag) && tag !== 'H3' || (tag === 'H3' && isUpperHead(txt))) {
      if (!txt) return;
      push(); cur = { head: txt, html: '' }; return;
    }
    if (tag === 'P') {
      var parts = el.innerHTML.split(/<br\s*\/?>/i);
      var first = parts[0].replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').trim();
      if (first && isUpperHead(first)) {
        push(); cur = { head: first, html: '' };
        var restParts = parts.slice(1);
        var f2 = (restParts[0] || '').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').replace(/&amp;/g, '&').trim();
        if (restParts.length > 1 && isSub(f2)) { cur.html += '<h3 class="gcg-sub">' + esc(f2) + '</h3>'; restParts = restParts.slice(1); }
        var rest = restParts.join('<br>').trim();
        if (rest) cur.html += '<p>' + rest + '</p>';
        return;
      }
      /* Sous-titre en minuscules suivi d'un retour à la ligne : "Comment modifier ou annuler<br>…" */
      if (parts.length > 1 && isSub(first)) {
        cur.html += '<h3 class="gcg-sub">' + esc(first) + '</h3><p>' + parts.slice(1).join('<br>') + '</p>';
        return;
      }
    }
    cur.html += el.outerHTML;
  });
  push();

  /* Retire un titre qui répète le titre de la page (ex. "POLITIQUE DE RETOUR ET DE REMBOURSEMENT") */
  var pageNames = [head[0], h1 ? h1.textContent : ''].map(normTitle);
  var intro = '';
  if (blocks.length && blocks[0].head === null) { intro = blocks.shift().html; }
  if (blocks.length && blocks[0].head) {
    var n0 = normTitle(blocks[0].head);
    var dup = pageNames.some(function (p) { return p && (n0 === p || p.indexOf(n0) === 0 || n0.indexOf(p) === 0); }) ||
      /^(politique|conditions?g|mentionsl)/.test(n0) && !/^article/i.test(blocks[0].head);
    if (dup && blocks.length > 1) { intro += blocks.shift().html; }
  }
  if (!blocks.length) { blocks = [{ head: head[0], html: intro }]; intro = ''; }

  /* 2. Construit la page */
  var toc = '', cards = '';
  blocks.forEach(function (b, i) {
    var num = i + 1, title = b.head || head[0];
    var m = title.match(/^\s*article\s+(\d+)\s*[–\-:.]?\s*(.*)$/i);
    if (m) { num = +m[1]; title = m[2] || title; }
    title = nice(title);
    var id = 'p' + (i + 1);
    toc += '<a class="gcg-pill" href="#' + id + '"><span>' + num + '</span>' + esc(title) + '</a>';
    cards += '<section class="gcg-card" id="' + id + '"><div class="gcg-num">' + num + '</div><div class="gcg-body"><h2><small>' +
      (m ? 'Article ' + num : 'Partie ' + num) + '</small>' + esc(title) + '</h2>' + b.html + '</div></section>';
  });

  var introClean = intro.replace(/<p>(\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, '').trim();
  var html =
    '<section class="gcg"><div class="gcg-wrap">' +
      '<header class="gcg-head"><p class="gcg-label">Informations légales</p>' +
      '<h1 class="gcg-title"><span class="gcg-title-b">' + esc(head[0]) + '</span>' +
      (head[1] ? '<span class="gcg-title-i">' + esc(head[1]) + '</span>' : '') + '</h1>' +
      (introClean ? '<div class="gcg-intro-card">' + introClean + '</div>' : '') +
      '</header>' +
      '<div class="gcg-grid' + (blocks.length > 1 ? '">' + '<nav class="gcg-toc" aria-label="Sommaire">' + toc + '</nav>' : ' gcg-grid--solo">') +
      '<div class="gcg-list">' + cards + '</div></div>' +
      '<div class="gcg-cta"><p>Une question ? Contactez <strong>GRENADINE</strong>.</p>' +
      '<a class="gcg-btn" href="/pages/contact-1">Nous contacter</a></div>' +
    '</div></section>';
  C.insertAdjacentHTML('beforeend', html);
  C.classList.add('gcg-on');
})();
